import React from 'react';
import Img3 from './SurfResultImageListImage';

class SurfResultImageList extends React.Component{
    state = {picLoadingQueue : 0 };

    componentDidMount() {
        this.setState({picLoadingQueue : 0 },()=>{});
    }
    
    nextPicLoadingStart = () => { 
        if(this.state.picLoadingQueue)
        {
            if (this.state.picLoadingQueue<this.props.bookVersionListData.length)
            {
                this.setState({picLoadingQueue : this.state.picLoadingQueue + 1},()=>{})
            }
        }
        else
        {
            this.setState({picLoadingQueue : 1 },()=>{}) 
        }
    }

    render (){
        return (
            [
                <div style={{width: "100%",height: "auto", backgroundColor:"transparent",float:"right",padding:"3px",textAlign:"center"}} key={'SRIL1'}>
                    {
                        this.props.bookVersionListData.map((BookVersionData,i) =>{
                            return  (
                                [
                                    <a style={{padding:"10px"}} href={"#Page"+(i+1)} onClick={()=>{return false}} key={'SRIL21i'+i}>{i+1}</a>
                                    ,
                                    ((i+1)%15===0)
                                    ?
                                    <br key={'SRIL22i'+i}/>
                                    :
                                    null
                                ]
                            )
                        })                               
                    }
                </div>
                ,
                <div id="pdf_window"  key={'SRIL3'}>
                    <div id="pdf_window_content">
                    {
                        this.props.bookVersionListData.map((bookVersionData,i) =>{
                            return  (
                                <Img3 key={"a"+i+"key={'SRIL3'}"} 
                                    class="book_img"
                                    imageCode={bookVersionData.Code}
                                    picTurn = {i}
                                    picLoadingQueue = {this.state.picLoadingQueue}
                                    nextPicLoadingStart={this.nextPicLoadingStart}
                                />
                                
                            )
                        })
                    }
                    </div>       
                </div>
            ]
        ) 
    }
}

export default SurfResultImageList;